<template>
  <div class="fair-survey-step fair-survey-step--centered">
    <div class="fair-survey-step__head fair-survey-step__head--centered">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle results-choice-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TasteStep } from '@/features/taste/types/taste-config'

defineProps<{ step: TasteStep & { type: 'choice' } }>()
</script>

<style scoped>
.fair-survey-step--centered {
  justify-content: center;
  align-items: center;
}

.results-choice-step__subtitle {
  max-width: 480px;
  text-align: center;
}
</style>
